import { getPublicityAll, getPublicityId, sendPublicity } from "../../interpreter/publicity";
import React, { useEffect, useState } from "react";
import AppDataTable from "./AppDataTable";
import PublicitySee from "../modals/seedPublicityId";
import Icon from "@mdi/react";
import { mdiPencilOutline, mdiEyeOutline, mdiSend } from "@mdi/js";
import "./AppDataTable.css";

const getStatusBadge = (status) => {
  const active = status == 1;
  return (
    <span className={`table-badge ${active ? "table-badge--active" : "table-badge--muted"}`}>
      {active ? "Activo" : "Deshabilitado"}
    </span>
  );
};

export const PublicityList = ({ openModal, publicitys, setPublicitys }) => {
  const [loading, setLoading] = useState(true);
  const [selectedPublicity, setSelectedPublicity] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchPublicity = async () => {
    try {
      setLoading(true);
      const data = await getPublicityAll();
      if (Array.isArray(data) && data.length > 0) {
        setPublicitys(data);
      } else {
        setPublicitys([]);
      }
    } catch (error) {
      console.error("❌ Error al obtener las publicidades:", error);
      setPublicitys([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPublicity();
  }, [setPublicitys]);

  const handleViewDetails = async (id) => {
    try {
      const publicity = await getPublicityId(id);
      if (publicity) {
        setSelectedPublicity(publicity.data.getPublicityId.publicity);
        setIsModalOpen(true);
      }
    } catch (error) {
      return [];
    }
  };

  const handleSendPublicity = async (id) => {
    try {
      const publicitySend = await sendPublicity(id);
      if (publicitySend) {
        alert("Envio exitoso de las publicidades!!");
      } else {
        alert("Surgio un problema en el envio de publcidades!!");
      }
    } catch (err) {
      alert("Se produjo un error en el servidor.");
      console.warn("error es: ", err);
    }
  };

  const columns = [
    {
      name: "Cod",
      selector: (row) => `00${row.id}`,
      sortable: true,
      center: true,
      width: "80px",
      minWidth: "70px",
    },
    {
      name: "Nombre Comercial",
      selector: (row) => row.commercialName,
      sortable: true,
      center: true,
      wrap: true,
      grow: 2,
      minWidth: "130px",
    },
    {
      name: "Categoría",
      selector: (row) => row.category?.description ?? "N/A",
      sortable: true,
      center: true,
      wrap: true,
      minWidth: "100px",
    },
    {
      name: "Estado",
      cell: (row) => getStatusBadge(row.status),
      sortable: true,
      center: true,
      minWidth: "110px",
    },
    {
      name: "Acciones",
      cell: (row) => (
        <div className="table-actions table-actions--stack-sm">
          <button
            type="button"
            onClick={() => openModal("reset", row)}
            className="table-action table-action--labeled table-action--primary"
            title="Modificar publicidad"
          >
            <Icon path={mdiPencilOutline} size={0.95} />
            <span className="table-action__label">Editar</span>
          </button>
          <button
            type="button"
            onClick={() => handleViewDetails(row.id)}
            className="table-action table-action--labeled table-action--secondary"
            title="Ver detalles"
          >
            <Icon path={mdiEyeOutline} size={0.95} />
            <span className="table-action__label">Ver detalle</span>
          </button>
          <button
            type="button"
            onClick={() => handleSendPublicity(row.id)}
            className="table-action table-action--labeled table-action--success"
            title="Enviar publicidad"
          >
            <Icon path={mdiSend} size={0.95} />
            <span className="table-action__label">Enviar</span>
          </button>
        </div>
      ),
      center: true,
      minWidth: "220px",
      grow: 1,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div>
      {loading ? (
        <div className="table-loading">
          <div className="table-loading__spinner" role="status" aria-label="Cargando publicidades" />
        </div>
      ) : (
        <>
          <AppDataTable
            columns={columns}
            data={Array.isArray(publicitys) ? publicitys : []}
            noDataComponent={<p className="table-empty">No hay publicidad disponible.</p>}
          />
          <PublicitySee
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            publicity={selectedPublicity}
          />
        </>
      )}
    </div>
  );
};
